import Utils from '../utils/util';
import Store from './store/index';

function sortByLeft(cubeIds: CubeId[]): CubeId[] {
    let temp: Array<FreeObjMap> = cubeIds.map((cubeId: CubeId): FreeObjMap => {
        return {
            cubeId,
            left: Store.getPhysicsCoordinate(cubeId).left
        };
    });
    let sortTemp: Array<FreeObjMap> = Utils.quickSortByKey(temp, 'left');

    return sortTemp.map((item: FreeObjMap): CubeId => {
        return item.cubeId;
    });
}

export {
    sortByLeft
};
